import React, { useEffect, useState, type ReactElement } from 'react'
import { Stepper, Step, StepLabel } from '@mui/material'
import InactiveAccount from 'features/authentication/inactive-account'
import { useAppSelector } from 'store/hooks'

import RequestVerification from '../request-verification'
import UnverifiedAccount from '../unverified-account'
import VendorProfile from '../vendor-profile'
import VendorProfileLayout from '../vendor-profile-layout'
import { VendorStatus } from '../vendor.types'
import Verification from '../verification'
import AdditionalDocuments from '../verification/aditional-documents'

import styles from './RegistrationWizard.module.scss'

const registrationSteps = [
  'Verifikacija APR email-a',
  'Slanje zahteva za verifikaciju',
  'Verifikacija od strane admina',
]

const getCurentStep = (status: VendorStatus | undefined): number => {
  switch (status) {
    case VendorStatus.pending:
    case VendorStatus.new:
      return 0
    case VendorStatus.activated:
      return 1
    case VendorStatus.additional_documents:
    case VendorStatus.pending_documents:
    case VendorStatus.pendingVerification:
    case VendorStatus.rejected:
      return 2
    default:
      return 0
  }
}

const DisplayRegistrationStep = (): JSX.Element => {
  const { vendor } = useAppSelector((state) => state.vendor)
  switch (vendor?.status) {
    case VendorStatus.pending:
    case VendorStatus.new:
      return <InactiveAccount />
    case VendorStatus.activated:
      return (
        <VendorProfileLayout>
          <UnverifiedAccount />
        </VendorProfileLayout>
      )
    case VendorStatus.additional_documents:
    case VendorStatus.pending_documents:
      return (
        <VendorProfileLayout>
          <Verification
            status={vendor.status}
            text={vendor.verificationNote ?? ''}
            additionalContent={<AdditionalDocuments />}
          />
        </VendorProfileLayout>
      )
    case VendorStatus.pendingVerification:
      return (
        <VendorProfileLayout>
          <Verification
            status={vendor.status}
            text={
              'Vaš zahtev za verifikaciju čeka na odobrenje od strane admina. Informaciju o promeni statusa ćete dobiti putem mail-a.'
            }
          />
        </VendorProfileLayout>
      )
    case VendorStatus.rejected:
      return (
        <VendorProfileLayout>
          <Verification
            status={vendor.status}
            text={vendor.verificationNote ?? ''}
            additionalContent={<RequestVerification />}
          />
        </VendorProfileLayout>
      )
    case VendorStatus.verified:
      return (
        <VendorProfileLayout>
          <VendorProfile />
        </VendorProfileLayout>
      )
    default:
      return <div>404 page</div>
  }
}

const RegistrtationWizard: React.FC = (): ReactElement => {
  const { vendor } = useAppSelector((state) => state.vendor)
  const [activeStep, setActiveStep] = useState<number>(0)

  useEffect(() => {
    setActiveStep(getCurentStep(vendor ? vendor.status : undefined))
  }, [vendor])

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {registrationSteps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        {<DisplayRegistrationStep />}
      </div>
    </div>
  )
}

export default RegistrtationWizard
